import { useState, useEffect } from "react";
import { X } from "lucide-react";

export default function FilmModal({ film, onClose }) {
  const open = !!film;

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-bde-ink/90 backdrop-blur-sm p-4 md:p-10 animate-in fade-in duration-200"
      role="dialog"
      aria-modal="true"
      data-testid="film-modal"
      onClick={onClose}
    >
      <button
        type="button"
        aria-label="Close film"
        data-testid="film-modal-close"
        className="absolute top-4 right-4 md:top-8 md:right-8 inline-flex h-12 w-12 items-center justify-center bg-bde-pink text-white border-2 border-bde-cream hover:bg-bde-cream hover:text-bde-ink transition-colors z-10"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <X className="h-5 w-5" />
      </button>

      <div
        className="w-full max-w-5xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-2 border-bde-cream bg-bde-ink ink-shadow-lg">
          <div className="relative w-full aspect-video bg-black">
            <iframe
              key={film.id}
              src={`https://www.youtube.com/embed/${film.id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
              title={film.title}
              className="absolute inset-0 h-full w-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
        <p className="mt-4 font-display text-2xl md:text-3xl text-bde-cream text-center">
          {film.title}{film.venue ? <span className="text-bde-pink"> · {film.venue}</span> : null}
        </p>
      </div>
    </div>
  );
}
